import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../../../generic-components/Heading';
import AppLayout from '../../../../../generic-components/Layout';
import { APP_LAYOUT_STYLES } from '../../../../../generic-components/Layout/constants';
import { ReactComponent as EnvelopeIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-envelope.svg';
import { STYLES } from '../consts';
import { VIEWS_MAP } from '../../../../../router/constants';
import { NavigationHeader } from '../../../../../components/NavigationHeader';
import { ValidateFieldTypes, validateScheme } from '../../../../../helpers/inputUtils.helper';
import { LiliTextInput } from '../../../../../DesignSystem/LiliTextInput/LiliTextInput';
import { useStore } from '../../../../../store';
import { trackMixPanel } from '../../../../../services/mixpanel.service';

const AskYourVendor = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const moveMoneyData = useStore(state => state.moveMoneyData);
  const [notifyVendorEmail, setNotifyVendorEmail] = useState<string>(moveMoneyData.vendorData?.email || '');
  const [isValid, setIsValid] = useState(!!moveMoneyData.vendorData?.email);
  const [emailErrorMessage, setEmailErrorMessage] = useState<string>('');

  const onSubmitEmail = () => {
    trackMixPanel('Act On Ask Vendor Email Screen', { 'Is Email Prefilled?': !!moveMoneyData.vendorData?.email });
    navigate(
      `/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.ASK_VENDOR.BASE}${VIEWS_MAP.BILLS.ASK_VENDOR.REVIEW}`,
      { state: { email: notifyVendorEmail } },
    );
  };

  useEffect(() => {
    trackMixPanel('View Ask Vendor Email Screen');
  }, []);

  useEffect(() => {
    if (!moveMoneyData.billId) {
      navigate(`/${VIEWS_MAP.BILLS.BASE}`);
    }
  }, []);

  return (
    <AppLayout
      layoutStyle={APP_LAYOUT_STYLES.CHOOSE_PAYMENT_METHOD.MAIN_LAYOUT_CHOOSE_METHOD}
      navBarStyle={`${APP_LAYOUT_STYLES.CHOOSE_PAYMENT_METHOD.NAVBAR_LAYOUT} gap-0`}
      hideCustomerProfile
      chatBotStyle='hidden'
    >
      <div className='h-full text-center flex flex-col w-full items-center'>
        <NavigationHeader
          onCloseAction={() => navigate(`/${VIEWS_MAP.BILLS.BASE}`)}
          pageTitle={t('ASK_YOUR_VENDOR.PAYMENT_METHOD_TITLE')}
          layoutStyle={STYLES.NAVIGATION_HEADER}
        />
        <div className='flex flex-col justify-between w-full items-center h-full'>
          <div className='flex flex-col w-[520px] items-center'>
            <EnvelopeIcon className='mt-16' />
            <Heading title={t('ASK_YOUR_VENDOR.TITLE')} className='mt-6 font-metricRMedium text-bw08 text-[28px]' />
            <Heading title={t('ASK_YOUR_VENDOR.SUBTITLE_1')} className='mt-3 font-metricR text-bw07 text-[16px]' />
            <Heading title={t('ASK_YOUR_VENDOR.SUBTITLE_2')} className='mt-2 font-metricR text-bw07 text-[16px]' />
            <div className='w-[360px] mt-9 mb-[24px]'>
              <LiliTextInput
                id='vendorEmailInputField'
                type='email'
                title={t('ASK_YOUR_VENDOR.YOUR_VENDOR_EMAIL')}
                value={notifyVendorEmail}
                errorMessage={emailErrorMessage}
                onChange={(newEmail) => {
                  setNotifyVendorEmail(newEmail);
                  if (validateScheme(newEmail, ValidateFieldTypes.EMAIL)) {
                    setIsValid(true);
                    setEmailErrorMessage('');
                  } else {
                    setIsValid(false);
                  }
                }}
                onBlur={() => {
                  const isNewEmailValid = validateScheme(notifyVendorEmail, ValidateFieldTypes.EMAIL);
                  setIsValid(isNewEmailValid);
                  setEmailErrorMessage(isNewEmailValid || notifyVendorEmail === '' ? '' : t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.INVALID_EMAIL'));
                }}
              />
            </div>
          </div>
          <div className='flex flex-col w-full items-center py-6'>
            <div className='w-full border-t border-bw03 pb-6' />
            <LiliButton
              onClick={onSubmitEmail}
              isLoading={false}
              disabled={!isValid}
              id='notifyVendor'
              className='w-[375px]'
              title={t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.CONTINUE')}
            />
          </div>
        </div>
      </div>

    </AppLayout>
  );
};

export default AskYourVendor;
